"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _GoogleDocs = _interopRequireDefault(require("composer-lib/data/model/GoogleDocs"));

var _constants = require("composer-lib/lib/constants");

var _I18n = _interopRequireDefault(require("I18n"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var _UIAbstractFloaty = _interopRequireDefault(require("UIComponents/tooltip/UIAbstractFloaty"));

var FLOATY_HORIZONTAL_OFFSET = 36;
var FLOATY_VERTICAL_OFFSET = 17;

var _default = (0, _createReactClass.default)({
  displayName: "GoogleDocsPicker",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    addToast: _propTypes.default.func.isRequired,
    auth: _propTypes.default.object,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    fetchGoogleAccessToken: _propTypes.default.func.isRequired,
    googleDocs: _propTypes.default.instanceOf(_GoogleDocs.default).isRequired,
    hideGoogleDocsPicker: _propTypes.default.func.isRequired,
    importGoogleDoc: _propTypes.default.func.isRequired,
    showGoogleAccountSwitcher: _propTypes.default.func.isRequired,
    uiSettings: _propTypes.default.instanceOf(_UISettings.default).isRequired
  },
  getInitialState: function getInitialState() {
    return {
      loaded: false
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var _this$props = this.props,
        auth = _this$props.auth,
        fetchGoogleAccessToken = _this$props.fetchGoogleAccessToken;

    if (auth.gates.has(_constants.GOOGLE_DRIVE_GATE)) {
      fetchGoogleAccessToken();

      if (window.gapi) {
        window.gapi.load('picker');
      }
    }
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props2 = this.props,
        googleDocs = _this$props2.googleDocs,
        uiSettings = _this$props2.uiSettings;

    if (nextProps.uiSettings.showGoogleDocsPicker && googleDocs.token !== nextProps.googleDocs.token) {
      this.removePicker();
      this.picker = this.createGoogleFilePicker(nextProps);
      this.picker.setVisible(true);
      return;
    }

    if (!uiSettings.showGoogleDocsPicker && nextProps.uiSettings.showGoogleDocsPicker) {
      this.picker = this.createGoogleFilePicker();
      this.picker.setVisible(true);
      return;
    }

    if (uiSettings.showGoogleDocsPicker && !nextProps.uiSettings.showGoogleDocsPicker) {
      this.removePicker();
      return;
    }
  },
  removePicker: function removePicker() {
    if (!this.picker) {
      return;
    }

    this.picker.setVisible(false);
    this.picker.dispose();
    this.picker = undefined;
  },
  hidePicker: function hidePicker() {
    this.setState({
      loaded: false
    });
    this.props.hideGoogleDocsPicker();
  },
  handleSelectGoogleDoc: function handleSelectGoogleDoc(data) {
    var _this$props3 = this.props,
        addToast = _this$props3.addToast,
        composerSettings = _this$props3.composerSettings,
        composition = _this$props3.composition,
        googleDocs = _this$props3.googleDocs,
        importGoogleDoc = _this$props3.importGoogleDoc;

    switch (data.action) {
      case 'loaded':
        {
          this.setState({
            loaded: true
          });
          break;
        }

      case window.google.picker.Action.CANCEL:
        {
          this.hidePicker();
          break;
        }

      case window.google.picker.Action.PICKED:
        {
          var fileId = data.docs[0].id;
          var compositionId = composition.data.get('id');
          var email = googleDocs.email;
          importGoogleDoc(fileId, compositionId, email, addToast, composerSettings);
          this.hidePicker();
          break;
        }

      default: // unknown action

    }
  },
  createGoogleFilePicker: function createGoogleFilePicker() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

    if (!window.google) {
      return null;
    }

    return new window.google.picker.PickerBuilder().addView(new window.google.picker.DocsView().setMimeTypes('application/vnd.google-apps.document')).setOAuthToken(props.googleDocs.token).setCallback(this.handleSelectGoogleDoc).setTitle(_I18n.default.text('composer-lib.googleDocsPicker.title')).build();
  },
  computeFloatyPosition: function computeFloatyPosition(_ref) {
    var contentDimensions = _ref.contentDimensions,
        targetBounds = _ref.targetBounds;
    var contentWidth = contentDimensions.width;
    var targetLeft = targetBounds.left,
        targetTop = targetBounds.top,
        targetWidth = targetBounds.width;
    var leftOffset = contentWidth + FLOATY_HORIZONTAL_OFFSET;
    var left = targetWidth + targetLeft - leftOffset;
    var top = targetTop + FLOATY_VERTICAL_OFFSET;
    return {
      left: left,
      top: top
    };
  },
  renderTetherContent: function renderTetherContent() {
    var _this$props4 = this.props,
        googleDocs = _this$props4.googleDocs,
        showGoogleAccountSwitcher = _this$props4.showGoogleAccountSwitcher;
    return _react.default.createElement("div", null, googleDocs.email, _react.default.createElement(_UILink.default, {
      className: "p-left-1",
      onClick: showGoogleAccountSwitcher
    }, "(", _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.googleDocsPicker.changeLink"
    }), ")"));
  },
  render: function render() {
    if (!this.state.loaded) {
      return null;
    }

    var target = document.querySelector('.picker-dialog');

    if (!target) {
      return null;
    }

    return _react.default.createElement(_UIAbstractFloaty.default, {
      computePosition: this.computeFloatyPosition,
      content: this.renderTetherContent(),
      target: target,
      zIndex: _constants.Z_INDEX_ABOVE_GOOGLE_PICKER
    }, _react.default.createElement("span", null));
  }
});

exports.default = _default;
module.exports = exports.default;